import { useState } from 'react';
import { Avatar, ImageUploadButton, SettingsRow } from '@wundo/ui';
import { ProfilePhotoDialog } from './ProfilePhotoDialog.tsx';
import { nameToAbbreviate } from './nameToAbbreviate.ts';
import type { CurrentUser } from '@wundo/client/auth.ts';
import { m } from '@/paraglide/messages.js';

export interface ProfilePhotoRowProps {
  user: CurrentUser;
}

/**
 * The picture on your own profile, and the way in to changing it. File types
 * and sizes are said in the dialog, next to the button that acts on them.
 */
export function ProfilePhotoRow({ user }: ProfilePhotoRowProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <SettingsRow label={m.settings_photo()}>
        <ImageUploadButton
          aria-label={
            user.profile_image_url ? m.settings_photo_change() : m.settings_photo_add()
          }
          onClick={() => setOpen(true)}
        >
          <Avatar
            className='size-full'
            src={user.profile_image_url}
            name={nameToAbbreviate(user)}
            seed={user.email ?? user.id}
          />
        </ImageUploadButton>
      </SettingsRow>

      {open && <ProfilePhotoDialog user={user} onClose={() => setOpen(false)} />}
    </>
  );
}
